/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsGetProjects$Params {

/**
 * The ID of the organization to retrieve projects from
 */
  organizationId: string;
}

export function organizationsGetProjects(http: HttpClient, rootUrl: string, params: OrganizationsGetProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefProjectData>>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetProjects.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiDefProjectData>>;
    })
  );
}

organizationsGetProjects.PATH = '/organizations/{organizationId}/projects';
